import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { ModalPreset } from "@modules/+new/shared/universal-modal/entities/modal-preset.interface";
import { UniversalModalService } from "@modules/+new/shared/universal-modal/universal-modal.service";
import { FailData } from "./entities/fail-data.interface";
import { FailTransforms } from "./entities/fail-transforms.interface";
import { ModalCloseReason } from "@modules/+new/shared/universal-modal/entities/modal-close-reason.enum";

@Component({
	selector: "modal-fail",
	templateUrl: "./fail.component.html",
	styleUrls: ["./fail.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class FailComponent implements ModalPreset<FailData>, OnInit {
	private readonly transforms: FailTransforms;
	public data: FailData;

	public constructor(
		@Inject(UniversalModalService) private modal,
		private cdr: ChangeDetectorRef
	) {}

	private setTransforms = async (): Promise<boolean> => {
		if (!this.transforms) {
			return false;
		}
		this.data = await this.transforms.transform(this.data || {});
		this.close = this.transforms.onDone || this.close;
		this.primary = this.transforms.onPrimary || this.primary;
		this.secondary = this.transforms.onSecondary || this.secondary;
	};

	public ngOnInit(): void {
		this.setTransforms().then(() => this.cdr.markForCheck());
	}

	// TODO: eslint fix
	/* eslint-disable @typescript-eslint/no-explicit-any */
	public close = (): any => this.modal.close(ModalCloseReason.close);
	public primary = (): any => null;
	public secondary = (): any => null;
}
